import { getSession } from '../libs/utils'
import { find, isArray } from 'lodash'
// 判断用户是否已经注册
export async function hasRegister(to, from, next){
  let userInfo = getSession('risUserInfo', 'object') || null
  let userAuth = getSession('userAuth', 'object') || null
  if (!userInfo || !userInfo.id || !userAuth || !isArray(userAuth.authMenus) || userAuth.authMenus.length < 1) {
    next({ name: 'login' })
    return false
  } else {
    next()
    return true
  }
}
// 判断用户权限是否可以显示本页面
export async function hasCurrentRole (to, from, next) {
  let userAuth = getSession('userAuth', 'object') || {}
  if (to.path && (to.path === '/ris/edit' || to.path === '/ris/editReportList' || to.path === '/ris/mark' || to.path === '/ris/reportHistory')) {
    if (!userAuth.roles || userAuth.roles.length <= 0 || !find(userAuth.roles, (role) => { return ['超级管理员', '审核报告', '编写报告', '高级医生', '后处理报告'].includes(role.rname)})) {
      next({name: '403'})
      return false
    }
  } else if (to.path && to.path === '/ris/queue') {
    if (!userAuth.roles || userAuth.roles.length <= 0 || !find(userAuth.roles, (role) => { return ['超级管理员', '护士', '检查运营'].includes(role.rname)})) {
      next({name: '403'})
      return false
    }
  } else if (to.path && to.path === '/ris/callNum') {
    if (!userAuth.roles || userAuth.roles.length <= 0 || !find(userAuth.roles, (role) => { return ['超级管理员', '技师'].includes(role.rname)})) {
      next({name: '403'})
      return false
    }
  } else {
    next()
    return true
  }
}